// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyBa24-cXXrfSJanr1idXZ2AYmV8EHen9lM",
    authDomain: "cars-39eaa.firebaseapp.com",
    projectId: "cars-39eaa",
    storageBucket: "cars-39eaa.appspot.com",
    messagingSenderId: "801337781394",
    appId: "1:801337781394:web:2c5794b1e2f382bd6f4a4b",
    measurementId: "G-PRYCXFJRLZ"
  };

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
